module.exports = "<div class=\"ic-block__header\">\n  <div class=\"ic-block__title\">{{name}}</div>\n  <div *ngIf=\"line\" class=\"ic-block__line\"></div>\n</div>\n<div class=\"ic-block__body\">\n  <ng-content></ng-content>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/layout/block/block.component.html
// module id = ./src/app/layout/block/block.component.html
// module chunks = main